import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import { FaBarcode } from 'react-icons/fa';
import { Grid, Typography } from '@mui/material';
import CountrySelector from 'components/basic/CountrySelector';
import CollectionItemHeader from '../layout/CollectionItemHeader';
import getTheme from '../../theme/theme';
import SerialNumbersCSVUploader from './serial-numbers/SerialNumbersCSVUploader';
import SerialNumbersUploadPreview from './serial-numbers/SerialNumbersUploadPreview';
import SerialNumbersTable from './serial-numbers/SerialNumbersTable';
import { useItems } from '../../hooks/atoms/items-hook';
import CollectionKeys from '../../hooks/molecules/collection-keys';
import AppLoader from '../basic/AppLoader';
import ItemsDropdownButton from './ItemsDropdownButton';

const useStyles = makeStyles((theme) => {
  return {
    root: {
      minWidth: 275,
    },
    bullet: {
      display: 'inline-block',
      margin: theme.spacing(0, 1),
      transform: 'scale(0.8)',
    },
    title: {
      fontSize: 14,
    },
    pos: {
      marginBottom: theme.spacing(1),
    },
    demo: {
      backgroundColor: '#f0f0f0',
      alignItems: 'center',
      marginLeft: '5%',
      marginRight: '5%',
    },
  };
});

const SerialNumbers = () => {
  const classes = useStyles();
  const [ thematicPackageRealName, setThematicPackageRealName ] = useState('');
  const [ thematicPackageId, setThematicPackageId ] = useState(0);
  const [ thematicPackageName, setThematicPackageName ] = useState(undefined);
  const [ location, setLocation ] = useState('Greece');
  const [ locationFilter, setLocationFilter ] = useState({ country: 'GR' });

  const handleLocation = (e) => {
    setLocation(e.target.value);
    if (e.target.value === 'Albania') {
      setLocationFilter({ country: 'AL' });
    } else if (e.target.value === 'Greece') {
      setLocationFilter({ country: 'GR' });
    } else if (e.target.value === 'India') {
      setLocationFilter({ country: 'IN' });
    } else if (e.target.value === 'Iraq') {
      setLocationFilter({ country: 'IQ' });
    }
  };

  const {
    itemsLoading: serialNumbersLoading,
    count: totalEntries,
  } = useItems(CollectionKeys.SERIAL_NUMBER);

  const [ loading, setLoading ] = useState(false);

  if (serialNumbersLoading || loading) {
    return <AppLoader />;
  }
  return (
    <>
      <Grid container spacing={ 2 }>
        <Grid
          item
          xs={ 12 }
          md={ [ 'iDNA PGx CNS Kit', 'iDNA Cardio Health', 'NutriGenetix Laboratories kit' ].includes(thematicPackageRealName) ? 8 : 10 }
        >
          <ItemsDropdownButton
            onChange={ (v) => {
              setLocation('Greece');
              setLocationFilter({ country: 'GR' });
              setThematicPackageName(v?.thematic_category_id?.name);
              setThematicPackageId(v.id);
              return setThematicPackageRealName(v.real_name);
            } }
            title='Thematic Packages'
            collection='thematicpackages'
          />
        </Grid>
        {[ 'iDNA PGx CNS Kit', 'iDNA Cardio Health', 'NutriGenetix Laboratories kit' ].includes(thematicPackageRealName) && (
          <Grid item xs={ 12 } md={ 2 }>

            <Typography
              variant='subtitle'
              color='initial'
              id='location-select-label'
            >
              Country
            </Typography>

            <CountrySelector value={ location } handleLocation={ handleLocation } />

          </Grid>
        )}

      </Grid>
      <div className={ classes.root }>
        <div style={ { display: 'flex', flexDirection: 'row', alignItems: 'center', marginBottom: getTheme().spacing(2) } }>
          <FaBarcode
            style={ { color: getTheme().palette.secondary.dark, marginRight: getTheme().spacing(2) } }
            size={ 36 }
          />
          <CollectionItemHeader
            title='Serial Numbers'
            subtitle={ `Entries: ${ totalEntries }` }
            actions={ (
              <>
              </>
            ) }
          />
        </div>
        <SerialNumbersTable packageId={ thematicPackageId } locationFilter={ locationFilter } />
        <SerialNumbersCSVUploader />
        <SerialNumbersUploadPreview
          thematicPackageId={ thematicPackageId }
          setLoading={ setLoading }
          thematicPackageName={ thematicPackageName }
          locationFilter={ locationFilter }
        />
      </div>

    </>
  );
};

export default SerialNumbers;
